import { BaseQueryApi } from "@reduxjs/toolkit/dist/query";
import i18n from "../../i18n";

export const getDefaultHeaders = (
  headers: Headers,
  endpoints: undefined | Pick<BaseQueryApi, "type" | "getState" | "extra" | "endpoint" | "forced">,
  accessToken?: string | undefined
) => {
  headers.set("Accept", "application/json;charset=UTF-8");

  const excludedEndpoints = ['postRecord', 'uploadFile', 'uploadUserAvatar', 'uploadTherapistIntroVideo', 'postFile', 'startProcessing'];

  if (!headers.has("Content-Type") && !excludedEndpoints.includes(endpoints?.endpoint || '')) {
    headers.set("Content-Type", "application/json");
  }

  if (accessToken) {
    headers.set("Authorization", `Bearer ${accessToken}`);
  }

  // Add current UI language to every request for server-side localization
  const currentLanguage = i18n?.language || localStorage.getItem("i18nextLng") || "he";
  headers.set("Accept-Language", currentLanguage);
  headers.set("X-App-Name", 'therapist');

  return headers;
};
